
export const prototypeName = 'MLv4p5b2ejC1lkAdJjWNfK2LLbVkxNS62QVQ6dbNHybDkwqwOZfnqlqR68VqSj6vkLOXq0ILQoZ46qzDu5GxayVM3DI5R9pZXVN2uxMxbaD';